import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import NavBar from "./components/NavBar/NavBar";
import Loader from "./components/Loader/Loader";
import { ROUTES } from "./utils/routeUtils";
import HandleClickOutside from "./utils/helpers/HandleOutsideClick";
import { AppContext } from "./utils/Context/AppContext";
import CitationModal from "./components/CitationModal/CitationModal";
import SideBar from "./components/SideBar/SideBar";
import NAV_ARROW from "./assets/doubleLeftArrow.png";
import { useMsal } from "@azure/msal-react";
import LoaderComponent from "./components/Loader/LoaderComponent";
import { checkAdminStatus } from "./utils/services/api";
const Layout = () => {
  const { appData, dispatch, loginLoading, setIsAdmin } =
    useContext(AppContext);
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const userData = accounts[0];
  const location = useLocation();
  const hasActiveMembership =
    userData?.idTokenClaims?.extension_NECAHasActiveMembership;

  const [route, setRoute] = useState();
  const [firstTime, setFirstTime] = useState(true);
  const [loader, setLoader] = useState(true);
  const [flag, setFlag] = useState(true);
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const isMobile = deviceWidth < 660;
  const idToken = localStorage.getItem("idToken");
  const loginClient = localStorage.getItem("userId");
  const path = window.location.pathname;
  const [showMobileSidebar, setShowMobileSideBar] = useState(false);
  const sidebarRef = useRef(null);
  const hamburgerRef = useRef(null);

  useEffect(() => {
    setLoader(true);
    const routeObj = ROUTES.find((item) => item.path === path);
    setRoute(routeObj);

    if (path === "/" && idToken) {
      if (
        [
          "niki-user6@neca.asn.au",
          "niki-user7@neca.asn.au",
          "niki-user8@neca.asn.au",
          "niki-user9@neca.asn.au",
          "niki-user10@neca.asn.au",
        ].includes(loginClient)
      ) {
        navigate("/chat?new_conversation");
      } else {
        navigate("/main");
      }
    } else if (!idToken) {
      navigate("/");
    }

    setLoader(false);
  }, [idToken, path]);

  const updateDeviceWidthChange = useCallback(() => {
    setDeviceWidth(window.innerWidth);
  }, []);

  // useEffect(() => {
  //   const isOnMainPage = location.pathname === "/main";

  //   if (hasActiveMembership === undefined) return;

  //   if (!hasActiveMembership && isOnMainPage) {
  //     navigate("/chat?new_conversation=true", { replace: true });
  //   }
  // }, [hasActiveMembership, location.pathname, navigate]);

  useEffect(() => {
    updateDeviceWidthChange();
    window.addEventListener("resize", updateDeviceWidthChange);
    return () => window.removeEventListener("resize", updateDeviceWidthChange);
  }, []);



  return (
    <div className="layout h-full w-full relative">
      {loginLoading ? (
        <LoaderComponent />
      ) : (
        <>
          {route?.isNavBarDisplay && (
            <header
              className={`header border-b-[3px] border-[#F1F3F6] shadow-sm bg-white ${
                !appData?.successModal && "z-10"
              }`}
            >
              <NavBar
                setShowMobileSideBar={setShowMobileSideBar}
                showMobileSidebar={showMobileSidebar}
              />
            </header>
          )}

          <main
            className={`w-full flex relative z-[0] bg-[#F1F3F6] ${
              route?.isNavBarDisplay ? "h-[calc(100%-60px)]" : "h-full"
            }`}
          >
            {isMobile && showMobileSidebar && (
              <div
                className="absolute top-0 left-0 h-full w-full bg-black opacity-30 z-[4]"
                onClick={() => setShowMobileSideBar(false)}
              ></div>
            )}

            {route?.isSideBarDisplay && (
              <>
                {/* Desktop Sidebar */}
                {!isMobile && appData.hideSidebar && (
                  <aside
                    ref={sidebarRef}
                    className="sm:relative absolute top-0 w-[235px] float-left sm:float-none z-[10]"
                    id="aside"
                  >
                    <SideBar
                      setFirstTime={setFirstTime}
                      flag={flag}
                      setFlag={setFlag}
                    />
                  </aside>
                )}

                {/* Mobile Sidebar */}
                {isMobile && showMobileSidebar && (
                  <aside
                    ref={hamburgerRef}
                    className="absolute top-0 left-0 w-[250px] h-full bg-white z-50 shadow-md transition-transform duration-300 transform translate-x-0"
                  >
                    <SideBar
                      setFirstTime={setFirstTime}
                      setShowMobileSideBar={setShowMobileSideBar}
                      flag={flag}
                      setFlag={setFlag}
                    />
                  </aside>
                )}

                {/* Sidebar collapse button */}
                {!appData.hideSidebar && !isMobile && (
                  <button
                    className="absolute top-[10px] h-[30px] max-w-[30px] mb-3 flex items-center justify-center gap-3 text-[#444791] rounded-[6px] w-full text-sm"
                    onClick={() =>
                      dispatch({ type: "hideSidebar", payload: true })
                    }
                  >
                    <img className="rotate-180" src={NAV_ARROW} alt="" />
                  </button>
                )}
              </>
            )}

            <Outlet />
          </main>
        </>
      )}

      {/* {appData?.activeCitation?.citationUrl?.length > 0 && (
        <CitationModal
          isOpen={appData?.activeCitation?.citationUrl.length > 0}
          onClose={() =>
            dispatch({
              type: "citationUrl",
              payload: false,
            })
          }
        />
      )} */}
      {appData?.modalOpen && (
        <CitationModal
          isOpen={appData.modalOpen}
          onClose={() =>
            dispatch({
              type: "MODAL_TOGGLE",
              payload: false,
            })
          }
        />
      )}
    </div>
  );
};

export default Layout;
